import { render, staticRenderFns } from "./layout-page-route.vue?vue&type=template&id=44078892"
import script from "./layout-page-route.vue?vue&type=script&lang=js"
export * from "./layout-page-route.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports